/**
 * Příjezd & odjezd (#info-prijezd) a Časté dotazy (#info-faq).
 * Obsah odpovídá skutečným pravidlům areálu a cenám v rezervačním systému.
 */

const TIMES: { unit: string; arrive: string; depart: string; note?: string }[] = [
  { unit: 'Pokoj penzionu', arrive: 'od 14:00', depart: 'do 10:00', note: 'rezervace přes Booking.com' },
  { unit: 'Rybářská chatka', arrive: 'od 16:00', depart: 'do 14:00', note: 'rybařit můžete až do 16:00' },
  { unit: 'Tiny house', arrive: 'od 15:00', depart: 'do 12:00', note: 'minimálně 2 noci' },
  { unit: 'Karavan', arrive: 'od 12:00', depart: 'do 12:00' },
  { unit: 'Bivak', arrive: '7:00 nebo 19:00', depart: '19:00 nebo 7:00', note: '12hodinové sloty, lze i několik dní po sobě' },
]

export function InfoPrijezd() {
  return (
    <section className="bg-paper py-12 md:py-20 min-h-screen">
      <div className="container-x max-w-3xl">
        <div className="text-[10px] uppercase tracking-[0.30em] text-brand-500 font-bold flex items-center gap-2">
          <span className="inline-block w-8 h-px bg-brand-500" />
          Sobáčov · Fishing &amp; Sport Resort
        </div>
        <h1 className="h-display text-4xl md:text-5xl mt-3">Příjezd &amp; odjezd</h1>
        <p className="text-ink-700 mt-3 text-sm">
          Časy se liší podle typu ubytování. Potřebujete-li přijet dřív nebo odjet
          později, ozvěte se — pokud to obsazenost dovolí, vyjdeme vstříc.
        </p>

        <div className="mt-10 card p-6 md:p-7">
          <h2 className="font-bold text-lg text-ink-900 tracking-tight">Časy podle ubytování</h2>
          <div className="mt-4 overflow-x-auto">
            <table className="w-full text-[15px] text-ink-800">
              <thead>
                <tr className="text-[10px] uppercase tracking-[0.12em] text-ink-700/60 font-semibold border-b border-ink-900/10">
                  <th className="text-left py-2 pr-3">Ubytování</th>
                  <th className="text-left py-2 pr-3">Příjezd</th>
                  <th className="text-left py-2">Odjezd</th>
                </tr>
              </thead>
              <tbody>
                {TIMES.map((t) => (
                  <tr key={t.unit} className="border-b border-ink-900/[0.06] align-top">
                    <td className="py-2.5 pr-3">
                      <div className="font-semibold text-ink-900">{t.unit}</div>
                      {t.note && <div className="text-[12.5px] text-ink-700">{t.note}</div>}
                    </td>
                    <td className="py-2.5 pr-3 tabular-nums">{t.arrive}</td>
                    <td className="py-2.5 tabular-nums">{t.depart}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-8 space-y-8">
          <div className="card p-6 md:p-7">
            <h2 className="font-bold text-lg text-ink-900 tracking-tight">Kde se hlásit</h2>
            <div className="mt-3 text-[15px] text-ink-800 leading-relaxed">
              <p>
                Při příjezdu se hlaste na recepci penzionu, tel.{' '}
                <a href="tel:+420775140705" className="font-semibold text-ink-900 hover:text-brand-600">+420 775 140 705</a>.
                Pro rybolov, chatky a sport volejte{' '}
                <a href="tel:+420775433401" className="font-semibold text-ink-900 hover:text-brand-600">+420 775 433 401</a>.
              </p>
              <p className="mt-2">
                Adresa: Sobáčov 111, 783 21 Mladeč. Parkování je u všech typů ubytování
                zdarma přímo v areálu.
              </p>
            </div>
          </div>

          <div className="card p-6 md:p-7">
            <h2 className="font-bold text-lg text-ink-900 tracking-tight">Bivak — jak fungují sloty</h2>
            <div className="mt-3 text-[15px] text-ink-800 leading-relaxed">
              <p>
                Bivak se rezervuje po dvanáctihodinových slotech: denní 7:00–19:00 a
                noční 19:00–7:00. Můžete si vzít jen jeden slot, oba (celých 24 hodin)
                nebo pobyt přes několik dní — v rezervaci vyberete den a čas příjezdu
                i odjezdu a systém spočítá počet slotů.
              </p>
              <p className="mt-2">
                V areálu je 7 očíslovaných míst pro bivak; konkrétní místo si vybíráte
                při rezervaci, včetně mapy sektorů.
              </p>
            </div>
          </div>

          <div className="card p-6 md:p-7">
            <h2 className="font-bold text-lg text-ink-900 tracking-tight">Pozdní příjezd a zrušení</h2>
            <div className="mt-3 text-[15px] text-ink-800 leading-relaxed">
              <p>
                Plánujete-li příjezd mimo uvedené časy, dejte nám prosím vědět předem
                telefonicky. Podmínky pro zrušení nebo přesun rezervace najdete
                v{' '}
                <a href="#podminky" className="font-semibold text-ink-900 hover:text-brand-600">
                  Obchodních podmínkách
                </a>.
              </p>
            </div>
          </div>
        </div>

        <a href="#top" onClick={() => { window.location.hash = '' }} className="btn-outline-dark mt-8">
          Zpět na hlavní stránku
        </a>
      </div>
    </section>
  )
}

const FAQ: { q: string; a: React.ReactNode }[] = [
  {
    q: 'Musím rybářskou povolenku rezervovat předem?',
    a: (
      <p>
        Ne — povolenku nelze rezervovat předem. Vystavujeme ji na místě a uhradíte ji
        hotově nebo kartou. Ceník začíná na 300 Kč za 6 hodin, celý najdete v sekci
        Volný čas → Rybolov.
      </p>
    ),
  },
  {
    q: 'Jaké ryby jsou v rybníce?',
    a: <p>Kapr, jeseter, candát, amur a koi kapr. Rybník má 3 hektary a tři přírodní ostrovy; obsádku pravidelně dosazujeme.</p>,
  },
  {
    q: 'Jak si rezervuji pokoj v penzionu?',
    a: (
      <p>
        Pokoje penzionu se rezervují přes Booking.com — tlačítko „Rezervovat" u pokoje
        vás tam přesměruje. Ostatní ubytování i sportoviště rezervujete přímo zde na webu.
      </p>
    ),
  },
  {
    q: 'Kolik stojí tenis a beach volejbal?',
    a: (
      <p>
        Obojí 120 Kč za hodinu, rezervují se v hodinových slotech od 9:00 do 21:00.
        Míč zapůjčíme za 50 Kč. Sportoviště se platí 100 % předem online.
      </p>
    ),
  },
  {
    q: 'Můžu rezervaci sportoviště přesunout?',
    a: (
      <p>
        Ano, jednou a nejpozději 24 hodin před začátkem — z odkazu nebo kódu
        v potvrzovací SMS. Při zrušení kvůli počasí z naší strany dostanete voucher
        na 100 % s platností 90 dní.
      </p>
    ),
  },
  {
    q: 'Je v ceně parkování a Wi-Fi?',
    a: <p>Ano. U chatek, tiny house, bivaku i karavanu je parkování v areálu zdarma a Wi-Fi v ceně.</p>,
  },
  {
    q: 'Co si mám k chatce přibalit a co si můžu půjčit?',
    a: (
      <p>
        K rybářské chatce nabízíme zapůjčení podběráku (200 Kč / 24 h), vaničky
        (200 Kč / 24 h) a pouštěcího vaku (100 Kč / 24 h) — zaškrtnete je při rezervaci.
        Pruty rybník nepronajímá.
      </p>
    ),
  },
  {
    q: 'Je v tiny house sauna?',
    a: (
      <p>
        Ano, k tiny house patří plovoucí sauna s hot tubem, vlastní koupelna, kuchyňka,
        klimatizace a terasa u rybníka; na pokoji čeká láhev prosecca. Tiny house
        rezervujeme minimálně na 2 noci.
      </p>
    ),
  },
  {
    q: 'Máte elektrickou přípojku pro karavan?',
    a: <p>Ano, přípojku doobjednáte v rezervaci za 200 Kč / 24 h. Stání jsou čtyři, terén je vyrovnaný, k dispozici je voda, WC a Wi-Fi.</p>,
  },
  {
    q: 'Vaříte? Kdy má kiosek otevřeno?',
    a: (
      <p>
        Kiosek u rybníka má otevřeno denně od dubna do září. Polední menu na aktuální
        týden najdete v sekci Menu. Restauraci pronajímáme na akce a svatby až pro
        60 hostů, catering připravíme na míru.
      </p>
    ),
  },
  {
    q: 'Jak funguje dárkový poukaz?',
    a: (
      <p>
        Poukaz koupíte online, po zaplacení vám přijde kód. Uplatníte ho na ubytování
        i rybolov přímo u nás. Poukaz je nepřenosný na peníze a nelze ho použít
        opakovaně; podrobnosti jsou v{' '}
        <a href="#podminky" className="font-semibold text-ink-900 hover:text-brand-600">Obchodních podmínkách</a>.
      </p>
    ),
  },
  {
    q: 'Do kdy můžu zrušit pobyt bez poplatku?',
    a: (
      <p>
        U klasické ceny zdarma nejpozději <b>14 dní před příjezdem</b>. Při pozdějším
        zrušení nebo nedojezdu se účtuje 100 % z celého pobytu. Přesné znění
        včetně zvýhodněných sazeb najdete v{' '}
        <a href="#podminky" className="font-semibold text-ink-900 hover:text-brand-600">Obchodních podmínkách</a>.
      </p>
    ),
  },
  {
    q: 'Do kolika hodin je v areálu klid?',
    a: <p>Noční klid platí od 22:00 — hudba a hlasitý provoz jen do této hodiny. Celá pravidla jsou v sekci Pravidla rybolovu.</p>,
  },
]

export function Faq() {
  return (
    <section className="bg-paper py-12 md:py-20 min-h-screen">
      <div className="container-x max-w-3xl">
        <div className="text-[10px] uppercase tracking-[0.30em] text-brand-500 font-bold flex items-center gap-2">
          <span className="inline-block w-8 h-px bg-brand-500" />
          Sobáčov · Fishing &amp; Sport Resort
        </div>
        <h1 className="h-display text-4xl md:text-5xl mt-3">Časté dotazy</h1>
        <p className="text-ink-700 mt-3 text-sm">
          Nenašli jste odpověď? Zavolejte na{' '}
          <a href="tel:+420775140705" className="font-semibold text-ink-900 hover:text-brand-600">+420 775 140 705</a>{' '}
          nebo napište na{' '}
          <a href="mailto:rezervace.sobacov@gmail.com" className="font-semibold text-ink-900 hover:text-brand-600">
            rezervace.sobacov@gmail.com
          </a>.
        </p>

        <div className="mt-10 space-y-4">
          {FAQ.map((f) => (
            <details key={f.q} className="card p-5 md:p-6 group">
              <summary className="font-bold text-[16px] text-ink-900 tracking-tight cursor-pointer list-none flex items-start justify-between gap-3">
                <span>{f.q}</span>
                <span className="text-brand-500 shrink-0 text-lg leading-none mt-0.5 group-open:rotate-45 transition-transform">+</span>
              </summary>
              <div className="mt-3 text-[15px] text-ink-800 leading-relaxed">{f.a}</div>
            </details>
          ))}
        </div>

        <a href="#top" onClick={() => { window.location.hash = '' }} className="btn-outline-dark mt-8">
          Zpět na hlavní stránku
        </a>
      </div>
    </section>
  )
}
